import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from './../auth/auth.service';
import { HeaderService } from './../services/header/header.service';
// import { AppleLoginProvider } from '../providers/apple-login.provider';

import { SocialAuthService, GoogleLoginProvider, SocialUser } from 'angularx-social-login';
import { CommonService } from '../services/common/common.service';
import { HttpService } from '../services/http/http.service';
import { config } from '../config';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.sass']
})
export class LoginComponent implements OnInit {
  socialUser: SocialUser = {response: '', provider: '', email: '', id: '', name: '', photoUrl: '', firstName: '', lastName: '', authToken: '', idToken: '', authorizationCode: ''};

  constructor(private router: Router, private fb: FormBuilder,
    private authService: AuthService,
    private headerService: HeaderService,
    private socialAuthService: SocialAuthService,
    private commonService: CommonService,
    private httpService: HttpService
    // private appleLoginProvider: AppleLoginProvider
    ) { }

  form: any = {};
  formUsername:any = {};
  companyDetails$:any= {};

  private formSubmitAttempt: boolean = false;
  private formSubmitAttemptUsername: boolean = false;


  invalidLogins = false;

  ngOnInit() {
    this.commonService.gaEvent('login_initial', 'login', 'Initial Login Screen');
    this.authService.onCompanyDetails.subscribe(result => {
      this.companyDetails$ = result;
    });

    this.form = this.fb.group({
      userName: ['', Validators.required],
      password: ['', Validators.required]
    });

    this.formUsername = this.fb.group({
      userName: ['', Validators.required]
    });

    //Test login
    // const obj = {
    //   userName: 'pavankumar@filostech.com',
    //   password: 'Admin@123'
    // };
    // this.authService.login(obj);
    //Test login

    const data = {
      title: this.companyDetails$.name || 'Total Health & Fitness'
    };
    this.headerService.setHeaderData(data);
    this.socialAuthService.authState.subscribe((user) => {
      this.socialUser = user;
      console.log(JSON.stringify(user));
      this.authService.onLoginSuccess();
      console.log('User logged in');
    });
  }

  isFieldInvalid(field: string) {
    return (
      (!this.form.get(field).valid && this.form.get(field).touched) ||
      (this.form.get(field).untouched && this.formSubmitAttempt)
    );
  }

  isFieldUsernameInvalid(field: string) {
    return (
      (!this.formUsername.get(field).valid && this.formUsername.get(field).touched) ||
      (this.formUsername.get(field).untouched && this.formSubmitAttemptUsername)
    );
  }

  onUserNameSubmit() {
    if (this.formUsername) {
      this.httpService.getCall(`${config.apiUrl}/fetchusercompanies/${this.formUsername.value}`).subscribe(result => {

      }, err => {

      });
    }
    this.formSubmitAttemptUsername = true;
  }

  onSubmit() {
    this.commonService.gaEvent('general_login', 'general_submit', 'General Submit');

    if (this.form.valid) {
      this.authService.login(this.form.value);
    }
    //this.invalidLogins = true;
    this.formSubmitAttempt = true;
  }

  loginWithGoogle(): void {
    this.socialAuthService.signIn(GoogleLoginProvider.PROVIDER_ID);
  }

  // loginWithApple(): void {
  //   this.appleLoginProvider.signIn();
  // }
  
}
